// @flow

import * as Immutable       from 'immutable';
import PropTypes            from 'prop-types';
import { taxonomyPropType } from './taxonomy';

export type TaxonomyTermKeys =
  | '@id'
  | '@type'
  | 'id'
  | 'taxonomy'
  | 'name'
  | 'slug'
  | 'meta'
  | 'termDepth'
  | 'topLevelTerm'
  | 'parent'
  | 'relatedTerms'
  | 'children'
  | 'createdAt'
  | 'updatedAt'
  | 'deletedAt'
  | 'deleted'

export type TaxonomyTerm = Immutable.Map<TaxonomyTermKeys, *>;


const taxonomyTermShape = {
  '@id':        PropTypes.string.isRequired,
  '@type':      PropTypes.string.isRequired,
  taxonomy:     taxonomyPropType,
  name:         PropTypes.string,
  slug:         PropTypes.string,
  meta:         PropTypes.arrayOf(PropTypes.shape({
    '@id':     PropTypes.string.isRequired,
    '@type':   PropTypes.string.isRequired,
    id:        PropTypes.string.isRequired,
    metaName:  PropTypes.string.isRequired,
    metaValue: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  })),
  termDepth:    PropTypes.number.isRequired,
  topLevelTerm: PropTypes.string.isRequired,
  parent:       PropTypes.string,
  createdAt:    PropTypes.string.isRequired,
  updatedAt:    PropTypes.string.isRequired,
  deletedAt:    PropTypes.string.isRequired,
  deleted:      PropTypes.bool,
};

// $FlowFixMe
Object.assign(
  taxonomyTermShape,
  {
    relatedTerms: PropTypes.arrayOf(PropTypes.shape(taxonomyTermShape)),
    children:     PropTypes.arrayOf(PropTypes.shape(taxonomyTermShape)),
  },
);

const taxonomyTermShapeWithinResource = {
  '@id':   PropTypes.string.isRequired,
  '@type': PropTypes.string.isRequired,
  name:    PropTypes.string,
  slug:    PropTypes.string,
};


const taxonomyTermPropType = PropTypes.shape(taxonomyTermShape);


export {
  taxonomyTermShape,
  taxonomyTermShapeWithinResource,
  taxonomyTermPropType,
};



// WEBPACK FOOTER //
// ./src/domain/taxonomyTerm.js